export default {"src":"/_next/static/media/handshake.42acc367.svg","height":18,"width":24,"blurWidth":0,"blurHeight":0};